import { endpoints } from "../Api/configs";
import apiClient from "./apiClient";

export const fetchTicketsSoldOverview = async (accessToken: string) => {
  const bodyParams = { accessToken };

  return apiClient(endpoints.tickets.ticketsSoldOverview, {
    method: "POST",
    body: JSON.stringify({
      body: bodyParams,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
